import { useState } from 'react';
import { Col, Drawer, Form, Input, message, Row, Select, Switch } from 'antd';
import { drawerWidth, formItemLayout, notifyMessages } from '../../utils/constants';
import { DrawerFormButtons } from '../../components/common/drawersFormButtons';
import SuppliersServices from '../../services/suppliersServices';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { errorAlertDisplay } from '../../utils/functions';
import { useDocumentCategoryContext } from '../../context/documentCategoryContext';


const UpdateSupplier = ({ open, onClose, getSuppliers, recordData }) => {

    const [fieldsChanged, setFieldsChanged] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);
    const { documentCategories } = useDocumentCategoryContext();

    const saveData = async (values) => {
        values["supplierID"] = recordData.id;
        setLoadingButton(true);
        try {
            const respData = await SuppliersServices.updateSupplier(values);
            if (respData.success) {
                message.success(notifyMessages.operationSuccess);
                setLoadingButton(false);
                getSuppliers();
                onClose();
            }
            else {
                errorAlertDisplay(respData);
                setLoadingButton(false);
            }
        } catch (error) {
            message.error(notifyMessages.errorAccured);
            setLoadingButton(false);
        }
    }
    const categoryList = documentCategories.map(item => ({ value: item.id, label: item.description }));

    return (
        <Drawer
            title="Modifica Fornitore"
            width={drawerWidth}
            onClose={onClose}
            destroyOnClose={true}
            open={open}
            extra={
                <DrawerFormButtons disabled={!fieldsChanged} close={onClose} loadingButton={loadingButton} formId={"updateSupplier"} />
            }
        >
            <Form
                id="updateSupplier"
                layout="vertical"
                {...formItemLayout}
                onFinish={(values) => saveData(values)}
                onValuesChange={() => setFieldsChanged(true)}
            >
                <Row gutter={16}>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label="Nome"
                            name="name"
                            rules={[{ required: true, message: notifyMessages.requiredField }]}
                            initialValue={recordData.name}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label="Partita Iva"
                            name="vatCode"
                            rules={[{ required: true, message: notifyMessages.requiredField }]}
                            initialValue={recordData.vatCode}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    {/* <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label="Tipo documento"
                            name="categoryID"
                            rules={[{ required: true, message: notifyMessages.requiredField }]}
                            initialValue={recordData.categoryID}
                        >
                            <Select
                                options={categoryList}
                            />
                        </Form.Item>
                    </Col> */}

                    <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 4 }} lg={{ span: 4 }}>
                        <Form.Item
                            label="Abilitato"
                            name="enabled"
                            valuePropName="checked"
                            initialValue={recordData.enabled}
                        >
                            <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    );
}
export default UpdateSupplier;